import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  chip: {
    borderRadius: anatomy.borderRadiusXs,
    background: colors.ghostBackground,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.primaryText,
  },
  chipBrandGhost: {
    background: colors.brandGhostHoverBackground,
  },
  chipContent: {
    display: 'flex',
    padding: `${anatomy['space-4']} ${anatomy['space-4']} ${anatomy['space-4']} ${anatomy['space-8']}`,
    alignItems: 'center',
    gap: anatomy['space-4'],
  },
  chipContentCounterPadding: {
    padding: `${anatomy['space-2']} ${anatomy['space-4']} ${anatomy['space-2']} ${anatomy['space-8']}`,
  },
  deleteButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.tertiaryIcon,
  },
});
